// pages/FAQPage.tsx
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import leftFlower from "../assets/leftFlower.png";
import rightFlower from "../assets/rightFlower.png";

interface FAQItem {
  question: string;
  answer: string;
  hasLink?: boolean;
  linkText?: string;
  linkUrl?: string;
}

const faqs: FAQItem[] = [
  {
    question: "When should I RSVP by?",
    answer:
      "We would love to accommodate all of our guests. To help us plan accordingly and ensure everyone is comfortably catered for, please kindly RSVP by 28th February",
  },
  {
    question: "What time should I arrive at the ceremony?",
    answer:
      "Please arrive by 3:45pm prompt, as the ceremony will begin shortly after.",
  },
  {
    question: "Is there a gifts registry?",
    answer:
      "For those of you who wish to bless us, we kindly ask for monetary gifts only, this will be greatly appreciated and thank you in advance!",
  },
  {
    question: "For all monetary gifts",
    answer:
      "Please use this button if you would like to bless our honeymoon fund",
    hasLink: true,
    linkText: "https://monzo.me/josephsani?h=pj8IZO",
    linkUrl: "https://monzo.me/josephsani?h=pj8IZO",
  },
  {
    question: "Is there a dress code?",
    answer:
      "Yes, the dress code is cocktail formal. We invite our guests to dress elegantly and stylishly. Think polished suits and smart shoes for men, and cocktail dresses or formal evening wear for women. Come dressed to impress and ready to celebrate with us.",
  },
  {
    question: "Can I bring a plus 1?",
    answer:
      "Due to the intimate nature of our celebration, we are keeping our wedding to close loved ones only. Invitations are extended specifically to those named, unless stated otherwise. We truly appreciate your understanding and can't wait to celebrate with you.",
  },
  {
    question: "Is there parking at the ceremony or reception?",
    answer:
      "Ceremony: There is free on-street parking. As the venue is in a residential area, we kindly ask our guests to avoid parking in front of our neighbours' driveways.\n\nReception: Yes, there's free parking on Stafford Road at any time and there's also free parking from 6pm onwards on surrounding roads.",
  },
  {
    question: "Who should I contact for more information?",
    answer:
      "Please contact our friendly coordinators, Lorraine Cabby 07460430212 or Sprinkle Harrison-Girling 07447931924.",
  },
];

const FAQPage = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section className="w-full bg-white pt-16 md:pt-24 px-6 relative">
      {/* Decorative floral elements - Right top (BEHIND content) */}
      <img
        src={rightFlower}
        alt=""
        className="absolute right-0 top-0 w-32 md:w-72 opacity-80 pointer-events-none z-0"
      />

      {/* Decorative floral elements - Left bottom (BEHIND content) */}
      <img
        src={leftFlower}
        alt=""
        className="absolute left-0 bottom-[-10%] w-32 md:w-72 opacity-80 pointer-events-none z-0"
      />

      <div className="max-w-6xl mx-auto">
        {faqs.map((faq, index) => (
          <div
            key={index}
            data-aos="fade-up"
            // data-aos-delay={index * 100}
            className="text-center mb-16"
          >
            {/* Question with mixed gradient */}

            <span className="text-2xl md:text-4xl bg-gradient-to-r from-[#C49355] to-[#E8B46A] bg-clip-text text-transparent mb-3">
              {faq.question}
            </span>

            {/* Answer */}
            <p
              className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-4xl mx-auto whitespace-pre-line"
              style={{
                fontFamily: "'Times New Roman', Times, serif",
                fontWeight: 400,
              }}
            >
              {faq.answer} <br />
              {faq.hasLink && (
                <>
                  {" "}
                  <a
                    href={faq.linkUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-600 hover:text-[#C49355] transition-colors"
                  >
                    <button
                      // onClick={() =>
                      //   openDirections("Venue 254, 350 Katherine Road, London, E7 8NW")
                      // }
                      className="bg-[#3d3d3d] hover:bg-[#2d2d2d] text-lg text-white px-16 py-3 transition-colors duration-300 mt-4"
                    >
                      Gift
                    </button>
                    {/* {faq.linkText} */}
                  </a>
                </>
              )}
            </p>
          </div>
        ))}
      </div>

      {/* Decorative divider line at top */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
    </section>
  );
};

export default FAQPage;
